<template>
  <div>
    <jc-form :model="form" :rules="rules" ref="ruleForm" label-width="105px">
      <jc-form-item :label="text.balance" prop="name">
         <span>{{form.balance}}</span>
      </jc-form-item>
      <jc-form-item :label="text.fee"  prop="fee">
          <jc-input :placeholder="text.validtext.valid3"  v-model="form.fee" style="width: 50%;"></jc-input>   
      </jc-form-item>
      <jc-form-item :label="$t('有效时间')">
        <span>{{form.time}}</span>
      </jc-form-item>
      <jc-form-item :label="`${$t('发放账号')}${$t('：')}`" prop="pointUser" >
       <jc-input  v-if="!restriction" :placeholder="$t('请输入用户账号')" v-model="form.pointUser" style="width:420px"></jc-input>
       <div v-else >
           <jc-button v-if="!form.pointUser" type="primary" @click="selectAccount">{{ $t('选择账号') }}</jc-button>
            <div v-else>
                <span style="padding-right:10px;">{{form.pointUser}}</span>
                <jc-button type="primary" @click="selectAccount">{{ $t('重新选择') }}</jc-button>
            </div>
        </div>
      </jc-form-item>
      <jc-form-item>
        <jc-button @click="cancel">{{ $t('取消') }}</jc-button>
        <jc-button type="primary" v-loading="loading" @click="submitForm('ruleForm')">{{ $t('确定') }}</jc-button>
      </jc-form-item>
    </jc-form>
  </div>
</template>
<script>
import getTranslation from '@/i18n/getTranslation'
import { pinValidate } from '@/api/coupon-api.js'
import { ISSUE_TEXT } from '@/utils/constant.js'
export default {
  name: 'basicForm',
  props: ['type', 'balance', 'time', 'restriction'],
  data() {
    var COUPON_REG = /^([1-9][0-9]{0,8})(\.\d{1,2})?$|^0(\.\d{1,2})?$/
    var feeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.text.validtext.valid1))
      } else {
        if (!Number(value)) {
          callback(new Error(this.text.validtext.valid2))
        }
        if (parseFloat(this.form.balance) < parseFloat(value)) {
          callback(new Error(getTranslation(this.text.validtext.valid3)))
        } else {
          callback()
        }
      }
    }
    var userValidate = (rule, value, callback) => {
      setTimeout(async () => {
        if (this.restriction === 1) {
          return callback()
        }
        if (value === '') {
          return callback(new Error(getTranslation('请输入用户PIN')))
        }
        try {
          this.loading = true
          let _result = await pinValidate({ pointUser: value })
          let result = _result.body.result
          if (result.success) {
            let { data } = result
            if (data.validate === 0) {
              return callback(new Error(getTranslation('该用户PIN无效')))
            } else {
              return callback()
            }
          } else {
            return callback(result.message)
          }
        } finally {
          this.loading = false
        }
      }, 400)
    }
    return {
      ISSUE_TEXT,
      text: ISSUE_TEXT.issue,
      form: {
        balance: '',
        fee: '',
        time: '',
        pointUser: ''
      },
      loading: false,
      rules: {
        fee: [
          {
            required: true,
            // message: getTranslation('请输入代金券金额'),
            trigger: 'blur'
          },
          {
            pattern: COUPON_REG,
            // message: text.validtext.valid4,
            trigger: 'blur'
          },
          { validator: feeValidate, trigger: 'blur' }
        ],
        pointUser: [
          {
            required: true,
            message: getTranslation('发放账号不能为空'),
            trigger: 'blur'
          },
          { validator: userValidate, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    balance(val) {
      this.form.balance = val
    },
    time(val) {
      this.form.time = val
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('firstStepData', this.form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    selectAccount() {
      this.$emit('selectAccount')
    },
    validateFuc(val) {
      this.form.pointUser = val
      this.$refs.ruleForm.validate()
    }
  },
  created() {
    if (this.type === 'issue') {
      this.text = ISSUE_TEXT.issue
    } else {
      this.text = ISSUE_TEXT.resend
    }

    this.rules.fee[0].message = this.text.validtext.valid1
    this.rules.fee[1].message = this.text.validtext.valid4
  }
}
</script>
